<template>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('class.name') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.name }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('family.relation') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.relation }}
          </dd>
        </div>

        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.dateOfBirth') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.date_of_birth }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('family.isEmployee') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.is_employee }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('family.isStudent') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.is_student }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.mobileNum') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.mobile_no }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('employee.email') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.email }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('vaccines.description') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ family.remarks }}
          </dd>
        </div>

      </dl>

    </div>

  </div>

</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
export default {
  name: 'ClassForm',
  components: {

  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])

    const family = reactive({})

    watchEffect(() => {
      const newClass = props.propObject
      Object.assign(family, newClass)
    })

    return {
      titleStack,
      family

    }
  }
}
</script>